// extracted by mini-css-extract-plugin
export default {"addToCartControl":"hZ-z","giftCard":"iZ-z","btnContainer":"jZ-z","cartButton":"kZ-z","disabled":"lZ-z"};